import { Navbar } from "../components"
import Footer from '../components/footer/Footer';
import ContactComponent from '../components/contact/Contact';

export default function Contact() {
    return (
        <div>
            <Navbar />
            <ContactComponent />
            <Footer />
        </div>
    )
}